import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import i18n from "../i18n";
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "../i18n/constants";

export const LANGUAGES = {
  az: { id: "az", label: "AZ", nameKey: "languages.az" },
  ru: { id: "ru", label: "RU", nameKey: "languages.ru" },
  en: { id: "en", label: "EN", nameKey: "languages.en" },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(i18n.language || DEFAULT_LANGUAGE);

  useEffect(() => {
    const onLanguageChanged = (lng) => {
      if (SUPPORTED_LANGUAGES.includes(lng)) {
        setLanguageState(lng);
      }
    };

    i18n.on("languageChanged", onLanguageChanged);
    return () => i18n.off("languageChanged", onLanguageChanged);
  }, []);

  const setLanguage = (next) => {
    if (!SUPPORTED_LANGUAGES.includes(next)) return;
    i18n.changeLanguage(next);
  };

  const value = useMemo(() => {
    const meta = LANGUAGES[language] || LANGUAGES.az;
    return {
      language,
      setLanguage,
      currentLanguage: {
        ...meta,
        name: i18n.t(meta.nameKey),
      },
    };
  }, [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return context;
}

export default LanguageContext;
